import { round } from "lodash";
import { Api_Url } from "./ApiUrl";

// 🔥 MAIN FUNCTION
export const getMergedProjectsConfig = async (PROJECTS_CONFIG, automationGraph) => {
    try {
        const response = await fetch(
            `${Api_Url}/pro-projects/minimal/list`
        );

        const result = await response.json();

        if (!result?.data) return PROJECTS_CONFIG;

        // Transform API response into PROJECTS_CONFIG structure
        const apiProjects = result.data.reduce((acc, project) => {
            const key = project.projectTicker.toUpperCase(); // key like TIGA, VERSIONTHREE etc

            acc[key] = {
                preSale: project.preSaleContract,
                claim: project.claimContract,
                graph: automationGraph, // API doesn't provide graph
                label: project.projectName,
                imageSrc: project.projectImage,
                rounds: project.saleRounds,
                automation:true, // Mark as API-sourced project
                ...project, // Include all API fields for potential future use

            };

            return acc;
        }, {});

        // Merge API projects on top of static config
        return {  autoProjects:{
            ...apiProjects,
        },
           combinedProjects: {
           
            ...apiProjects,
               ...PROJECTS_CONFIG,
           
        }}
    } catch (error) {
        console.error("Error fetching projects:", error);
        return PROJECTS_CONFIG; // fallback
    }
};
